// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const DispatchCancelDraftParameterChanges: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/CancelDraftParameterChanges",
    });
};

export const chain = [DispatchCancelDraftParameterChanges];

const cancelDraftParameterChanges = createHandlerChainRunnerOptionalParameter(chain, {}, "CancelDraftParameterChanges");
export default cancelDraftParameterChanges;
